import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  ITelefonoResponse, 
  ITelefonoRequest, 
  ITelefonoSaveRequest, 
  ITelefonoSaveResponse 
} from '../interfaces/telefono.interface';

@Injectable({
  providedIn: 'root'
})
export class TelefonoService {
  private readonly API_URL_LIST = `${environment.apiNewBackBaseUrl}ParametrosTelefono/cmspa_telefonList`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}ParametrosTelefono/cmspa_telefonAdd`;
  private readonly API_URL_UPDATE = `${environment.apiNewBackBaseUrl}ParametrosTelefono/cmspa_telefonUpd`;
  private readonly API_URL_DELETE = `${environment.apiNewBackBaseUrl}ParametrosTelefono/cmspa_telefonDelete`;

  constructor(private http: HttpClient) { }

  getTelefonos(request: ITelefonoRequest): Observable<ITelefonoResponse> {
    return this.http.post<ITelefonoResponse>(this.API_URL_LIST, request);
  }

  getTelefonoByNumero(telefono: string): Observable<ITelefonoResponse> {
    const payload: ITelefonoRequest = {
      que: 4,
      tope: "9999",
      telefono: telefono,
      primer_nombre: '',
      segundo_nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      calle: '',
      nombre_empresa: '',
      numero_ext: '',
      boletinado: '',
      tipoTelefono: ''
    };
    return this.http.post<ITelefonoResponse>(this.API_URL_LIST, payload);
  }

  saveTelefono(payload: ITelefonoSaveRequest): Observable<ITelefonoSaveResponse> {
    return this.http.post<ITelefonoSaveResponse>(this.API_URL_SAVE, payload);
  }

  updateTelefono(payload: ITelefonoSaveRequest): Observable<ITelefonoSaveResponse> {
    return this.http.post<ITelefonoSaveResponse>(this.API_URL_UPDATE, payload);
  }

  deleteTelefono(telefono: string): Observable<ITelefonoSaveResponse> {
    const payload: ITelefonoSaveRequest = {
      que: 3,
      tope: '',
      telefono: telefono,
      primer_nombre: '',
      segundo_nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      calle: '',
      nombre_empresa: '',
      numero_ext: '',
      boletinado: '',
      tipoTelefono: ''
    };
    return this.http.post<ITelefonoSaveResponse>(this.API_URL_DELETE, payload);
  }
} 